import React, { CSSProperties, FC } from 'react';
import styles from './SharingTruck.module.css';
import { useTheme } from '../../../../hooks/useTheme';

export interface SharingTruckIconProps {
  s?: CSSProperties;
  ariaTitle?: string;
}

const SharingTruckIcon: FC<SharingTruckIconProps> = ({ s = {}, ariaTitle }) => {
  const { iconsPrimaryNone: sharingTruckStyle } = useTheme();
  const style = { ...sharingTruckStyle, ...s };

  return (
    <svg
      className={styles.container}
      style={{ fill: style.color, ...style }}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden={!ariaTitle}
    >
      {ariaTitle && <title>{ariaTitle}</title>}
      <svg>
        <rect width="48" height="48" fill="none" />
        <path
          d="M23.3154 4C20.5757 4 18.4329 5.29063 17.0527 6.45625C15.6725 5.29063 13.5297 4 10.79 4C6.93126 4 3.78955 6.24375 3.78955 9C3.78955 11.7562 6.93126 14 10.79 14C13.5297 14 15.6725 12.7094 17.0527 11.5437C18.4329 12.7094 20.5757 14 23.3154 14C27.1742 14 30.3159 11.7562 30.3159 9C30.3159 6.24375 27.1742 4 23.3154 4ZM10.79 11C9.12383 11 7.7685 10.1031 7.7685 9C7.7685 7.89688 9.12383 7 10.79 7C12.3733 7 13.8139 8.95313 15 9.5C14.1545 10.3625 12.3692 11 10.79 11ZM23.3154 11C21.7321 11 19.8538 10.3719 19 9.5C20.0806 8.95313 21.7363 7 23.3154 7C24.9816 7 26.3369 7.89688 26.3369 9C26.3369 10.1031 24.9816 11 23.3154 11Z"
          fill="black"
        />
        <path
          d="M1 19H16V31H1.5C1.22386 31 1 30.7761 1 30.5V19Z"
          fill="black"
        />
        <path
          d="M0.5 11H16V17H0V11.5006C0 11.2244 0.223858 11 0.5 11Z"
          fill="black"
        />
        <path
          d="M18 19H33V30.5C33 30.7761 32.7761 31 32.5 31H18V19Z"
          fill="black"
        />
        <path
          d="M18 11H33.5C33.7761 11 34 11.2239 34 11.5V17H18V11Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.00006 39.5C6.00006 41.9853 8.01478 44 10.5001 44C12.9853 44 15.0001 41.9853 15.0001 39.5C15.0001 37.0147 12.9853 35 10.5001 35C8.01478 35 6.00006 37.0147 6.00006 39.5ZM8.57145 39.5C8.57145 40.5651 9.4349 41.4286 10.5 41.4286C11.5651 41.4286 12.4286 40.5651 12.4286 39.5C12.4286 38.4349 11.5651 37.5714 10.5 37.5714C9.4349 37.5714 8.57145 38.4349 8.57145 39.5Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35 39.5C35 41.9853 37.0147 44 39.5 44C41.9853 44 44 41.9853 44 39.5C44 37.0147 41.9853 35 39.5 35C37.0147 35 35 37.0147 35 39.5ZM37.6786 39.5C37.6786 40.5651 38.5421 41.4286 39.6072 41.4286C40.6723 41.4286 41.5358 40.5651 41.5358 39.5C41.5358 38.4349 40.6723 37.5714 39.6072 37.5714C38.5421 37.5714 37.6786 38.4349 37.6786 39.5Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M33 32H1V41H5.20703C5.07217 40.5232 5 40.02 5 39.5C5 36.4624 7.46243 34 10.5 34C13.5376 34 16 36.4624 16 39.5C16 40.02 15.9278 40.5232 15.793 41H33V32Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48 32H34V37.5H34.3749C35.175 35.4513 37.168 34 39.5 34C42.5376 34 45 36.4624 45 39.5C45 40.02 44.9278 40.5232 44.793 41H48V32Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M44 23H34V32H48L46 27.5L44 23ZM42 26H37V30H44L42 26Z"
          fill="black"
        />
      </svg>
    </svg>
  );
};

export default SharingTruckIcon;
